import { render, staticRenderFns } from "./ValueWithoutIcon.vue?vue&type=template&id=5fd6c206&scoped=true&"
import script from "./ValueWithoutIcon.vue?vue&type=script&lang=js&"
export * from "./ValueWithoutIcon.vue?vue&type=script&lang=js&"
import style0 from "./ValueWithoutIcon.vue?vue&type=style&index=0&id=5fd6c206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6c206",
  null
  
)

export default component.exports